/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnpaidPaymentItem } from './UnpaidPaymentItem';
import {
    UnpaidPaymentItemFromJSON,
    UnpaidPaymentItemFromJSONTyped,
    UnpaidPaymentItemToJSON,
    UnpaidPaymentItemToJSONTyped,
} from './UnpaidPaymentItem';

/**
 * 
 * @export
 * @interface UnpaidPaymentVo
 */
export interface UnpaidPaymentVo {
    /**
     * 待确认账单关联支付记录列表
     * @type {Array<UnpaidPaymentItem>}
     * @memberof UnpaidPaymentVo
     */
    records?: Array<UnpaidPaymentItem>;
}

/**
 * Check if a given object implements the UnpaidPaymentVo interface.
 */
export function instanceOfUnpaidPaymentVo(value: object): value is UnpaidPaymentVo {
    return true;
}

export function UnpaidPaymentVoFromJSON(json: any): UnpaidPaymentVo {
    return UnpaidPaymentVoFromJSONTyped(json, false);
}

export function UnpaidPaymentVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnpaidPaymentVo {
    if (json == null) {
        return json;
    }
    return {
        
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(UnpaidPaymentItemFromJSON)),
    };
}

export function UnpaidPaymentVoToJSON(json: any): UnpaidPaymentVo {
    return UnpaidPaymentVoToJSONTyped(json, false);
}

export function UnpaidPaymentVoToJSONTyped(value?: UnpaidPaymentVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(UnpaidPaymentItemToJSON)),
    };
}

